import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const ArrowLeft = createSvgIcon(React.createElement("polygon", { points: "11.1,20.5 12.5,19.1 6.4,13 21.4,13 21.4,11 6.4,11 12.5,4.9 11.1,3.5 2.6,12" }), 'ArrowLeft');
export default ArrowLeft;
